import {createStore} from 'redux';
import Reducers from './../reducers';

export default createStore(Reducers);


// WEBPACK FOOTER //
// ./src/store/index.jsx